import React, { useState, useEffect } from "react";
import { FaShare } from "react-icons/fa";
import { useParams, useNavigate } from "react-router-dom";
import surveyService from "../../Services/surveyService";
import { createPortal } from "react-dom";
import JoditEditor from "jodit-react";
import { useRef } from "react";
import NormalAlert from "../Alerts/NormalAlert";
// import ScheduleReminder from "../../Services/surveyService";

const ManageResponder = () => {
  const emailBodyRef = useRef("");
  const { assessmentUID } = useParams();
  const navigate = useNavigate();

  const [activeTab, setActiveTab] = useState("Responders");
  const [isAddResponderModalOpen, setIsAddResponderModalOpen] = useState(false);
  const [isAddReminderModalOpen, setIsAddReminderModalOpen] = useState(false);
  const [isUploadSuccess, setIsUploadSuccess] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [isUploading, setIsUploading] = useState(false);

  const [responders, setResponders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [surveyStats, setSurveyStats] = useState(null);

  const [emailSubject, setEmailSubject] = useState("");
  const [parameter, setParameter] = useState("");
  const [emailBody, setEmailBody] = useState("");
  const [date, setDate] = useState("");
  const [time, setTime] = useState("");
  const [onlyIncomplete, setOnlyIncomplete] = useState(false);
  const [errors, setErrors] = useState({});

  const [isViewReminderOpen, setIsViewReminderOpen] = useState(false);
  const [selectedReminder, setSelectedReminder] = useState(null);
  const [reminders, setReminders] = useState([]);

  const joditConfig = {
    readonly: false,
    height: 180,
    toolbarAdaptive: false,
    toolbarSticky: false,
    showCharsCounter: false,
    showWordsCounter: false,
    showXPathInStatusbar: false,

    buttons: [
      "bold",
      "italic",
      "underline",
      "|",
      "ul",
      "ol",
      "|",
      "link",
      "|",
      "undo",
      "redo",
    ],

    controls: {
      link: {
        exec: (editor) => {
          const url = prompt("Enter URL");

          if (!url) return;

          const text = editor.selection.sel?.toString() || "Click Here";

          const a = editor.createInside.element("a");
          a.href = url;
          a.textContent = text;
          a.target = "_blank";

          editor.selection.insertNode(a);
        },
      },
    },
  };

  const joditEditorInstance = useRef(null);

  //Alert
  const [alert, setAlert] = useState({
    show: false,
    type: "success",
    message: "",
  });

  const showAlert = (type, message) => {
    setAlert({ show: true, type, message });
  };

  useEffect(() => {
    const token = localStorage.getItem("JWTToken");
    const userID = localStorage.getItem("userID");

    if (!token || !userID) {
      navigate("/Login", { replace: true });
      return;
    }

    let isMounted = true;

    const fetchResponders = async () => {
      try {
        setLoading(true);
        const payload = {
          token,
          assessmentUID,
          userID: parseInt(userID, 10),
        };

        const response = await surveyService.GetSurveyResponders(payload);

        if (isMounted) {
          if (response.status === "Success" && response.respondersList) {
            console.log("Responders List:", response);
            setResponders(response.respondersList);
          } else {
            console.warn("No responders found");
            setResponders([]);
          }
        }
      } catch (error) {
        console.error("Error fetching responders:", error);
        if (isMounted) setResponders([]);
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    fetchResponders();

    const fetchSurveyData = async () => {
      try {
        const payload = {
          token: token,
          assessmentUID: assessmentUID,
        };
        const response = await surveyService.GetSurveyData(payload);
        if (response.status === "Success" && response.surveyData?.length > 0) {
          console.log("Survey Data:", response);
          setSurveyStats(response.surveyData[0]);
        } else {
          setSurveyStats(null);
          console.warn(response.message);
        }
      } catch (error) {
        console.log("Error Fetching Survey Data:", error);
        setSurveyStats(null);
      }
    };

    fetchSurveyData();

    const GetScheduledReminder = async () => {
      try {
        const payload = {
          token: token,
          surveyUID: assessmentUID,
        };

        const response = await surveyService.GetScheduledReminder(payload);

        if (
          response?.status === "Success" &&
          Array.isArray(response.schduledReminder)
        ) {
          const formatted = response.schduledReminder.map((r) => ({
            subject: r.emailSubject,
            body: r.emailBody,
            assessmentName: r.assessmentName,
            scheduledTime: r.scheduledTime,
            sendTo: r.sendTo,
            totalSent: r.totalMail,
            success: r.successMail,
            fail: r.failMail,
            status: r.status,
          }));

          console.log("UI Reminders:", formatted);
          setReminders(formatted);
        } else {
          setReminders([]);
        }
      } catch (error) {
        console.log("Error Fetching Scheduled Reminder:", error);
        setReminders([]);
      }
    };

    GetScheduledReminder();

    return () => {
      isMounted = false;
    };
  }, [assessmentUID, navigate]);

  useEffect(() => {
    if (isAddResponderModalOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isAddResponderModalOpen]);

  const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
    setIsUploadSuccess(false);
  };

  const handleUpload = async () => {
    if (!selectedFile) {
      showAlert("error", "Please select a file before uploading.");
      return;
    }
    setIsUploading(true);

    try {
      const response = await surveyService.createResponders(
        assessmentUID,
        selectedFile,
      );
      console.log("Upload Response:", response);

      if (response.status === "Success") {
        showAlert("success", response.message);
        setIsAddResponderModalOpen(false);
        setSelectedFile(null);
        setIsUploadSuccess(true);
        setTimeout(() => {
          window.location.reload();
        }, 3000);
      } else {
        showAlert("error", response.message || "Failed to upload responders");
      }
    } catch (error) {
      console.error(error);
      showAlert("error", "Error while uploading responders.");
    } finally {
      setIsUploading(false);
    }
  };

  const filteredResponders = responders.filter(
    (res) =>
      res.responderName?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      res.responderMail?.toLowerCase().includes(searchQuery.toLowerCase()),
  );

  const formatTime = (timeStr) => {
    if (!timeStr) return "0s";
    const [h, m, s] = timeStr.split(":").map(Number);
    let formatted = "";
    if (h) formatted += `${h}h:`;
    if (m) formatted += `${m}m:`;
    if (s) formatted += `${s}s`;
    return formatted.trim();
  };

  const containsSurveyLink = (html) => {
    if (!html) return false;

    if (html.includes("##SurveyLink##")) return true;

    const anchorRegex = /<a[^>]+href=["']([^"']+)["']/gi;
    let match;

    while ((match = anchorRegex.exec(html)) !== null) {
      if (match[1].includes("##SurveyLink##")) {
        return true;
      }
    }

    return false;
  };

  const validateReminderForm = () => {
    const newErrors = {};

    if (!emailSubject.trim()) {
      newErrors.emailSubject = "Email subject is required";
    }

    const bodyToValidate = emailBodyRef.current;

    if (
      !bodyToValidate ||
      bodyToValidate.replace(/<[^>]*>/g, "").trim() === ""
    ) {
      newErrors.emailBody = "Email body is required";
    } else if (!containsSurveyLink(bodyToValidate)) {
      newErrors.emailBody = "Email body must contain Survey Link";
    }

    if (!date) {
      newErrors.date = "Date is required";
    }

    if (!time) {
      newErrors.time = "Time is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const buildScheduledTime = () => {
    if (!date || !time) return null;
    return `${date}T${time}:00`;
  };

  return (
    <>
      <div className="min-h-[100vh] bg-[#f1f4f3] p-6 app-wrapper">
        {/* Top Metrics */}
        {!surveyStats ? (
          <p className="text-gray-500 text-lg">Loading Survey Data...</p>
        ) : (
          <>
            <div className="grid grid-cols-4 gap-4 text-center">
              <div>
                <p className="font-bold text-2xl mt-4">
                  {surveyStats.delivered ?? 0}
                </p>
                <p className="text-sm text-gray-600">Delivered</p>
              </div>
              <div>
                <p className="font-bold text-2xl mt-4">
                  {surveyStats.started ?? 0}
                </p>
                <p className="text-sm text-gray-600">Started</p>
              </div>
              <div>
                <p className="font-bold text-2xl mt-4">
                  {surveyStats.completed ?? 0}
                </p>
                <p className="text-sm text-gray-600">Completed</p>
              </div>
              <div>
                <p className="font-bold text-2xl mt-4">
                  {" "}
                  {formatTime(surveyStats.averageCompletionTime)}
                </p>
                <p className="text-sm text-gray-600 mb-7">
                  Average Completion Time
                </p>
              </div>
            </div>
          </>
        )}

        {/* Top Buttons */}
        <div className="flex justify-end gap-4 mb-14">
          <button
            className="bg-[#fc8e11] text-white px-4 py-2 rounded"
            onClick={() => setIsAddResponderModalOpen(true)}
          >
            Add Responders
          </button>

          <button
            className="bg-[#fc8e11] text-white px-4 py-2 rounded mr-20"
            onClick={() => setIsAddReminderModalOpen(true)}
          >
            Add Reminder
          </button>
        </div>

        {/* Tabs and Search */}
        <div className="flex justify-between items-center mb-4 ml-9">
          <div className="flex space-x-4 border-b border-gray-300">
            <button
              className={`pb-2 font-medium ${
                activeTab === "Responders"
                  ? "border-b-4 border-[#4fa69f] text-gray-800"
                  : "text-gray-500"
              }`}
              onClick={() => setActiveTab("Responders")}
            >
              Responders
            </button>
            <button
              className={`pb-2 font-medium ${
                activeTab === "Reminders"
                  ? "border-b-4 border-[#4fa69f] text-gray-800"
                  : "text-gray-500"
              }`}
              onClick={() => setActiveTab("Reminders")}
            >
              Reminders
            </button>
          </div>
          <input
            type="text"
            placeholder="Search..."
            className="border px-3 py-1 rounded mr-8"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </div>

        {/* Tab Content */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 ml-9">
          {/*RESPONDERS TAB*/}
          {activeTab === "Responders" && (
            <>
              {loading ? (
                <p className="text-gray-500">Loading Responders..</p>
              ) : responders.length === 0 ? (
                <p className="text-gray-500 text-center mt-6">
                  No Responders Found For this Survey.
                </p>
              ) : (
                responders.map((res) => (
                  <div
                    key={res.responderID}
                    className="bg-white p-5 rounded-xl shadow-md hover:shadow-lg transition-all duration-300 flex flex-col justify-between w-[300px] h-[180px]"
                  >
                    <div>
                      <h6 className="text-lg font-semibold text-gray-800 mb-1 capitalize">
                        {res.responderName}
                      </h6>
                      <p className="text-gray-500 text-sm mb-3">
                        {res.responderMail}
                      </p>

                      <p className="text-gray-600 text-sm">
                        <span className="font-medium">
                          Total Reminders Sent:
                        </span>{" "}
                        {res.totalReminderSent}
                      </p>
                      <p className="text-gray-600 text-sm">
                        <span className="font-medium">Last Reminder:</span>{" "}
                        {res.lastReminderTime
                          ? new Date(res.lastReminderTime).toLocaleString()
                          : "N/A"}
                      </p>
                    </div>

                    <div className="flex justify-end mt-3">
                      <FaShare
                        className="text-gray-700 cursor-pointer hover:text-[#4fa69f]"
                        onClick={() =>
                          window.open(
                            `/Participant-Response/${res.responderUID}`,
                            "_blank",
                          )
                        }
                      />
                    </div>
                  </div>
                ))
              )}
            </>
          )}

          {/* REMINDERS TAB*/}
          {activeTab === "Reminders" &&
            reminders.map((rem, index) => (
              <div
                key={index}
                onClick={() => {
                  setSelectedReminder(rem);
                  setIsViewReminderOpen(true);
                }}
                className="bg-white p-4 rounded-lg shadow hover:shadow-md transition w-[300px] h-[180px] cursor-pointer relative"
              >
                {/* STATUS BADGE */}
                <span
                  className={`absolute top-3 right-3 text-xs px-2 py-1 rounded-full font-medium
          ${
            rem.status === "Reminder sent"
              ? "bg-green-100 text-green-700"
              : rem.status === "Scheduled to remind"
                ? "bg-blue-100 text-blue-700"
                : "bg-yellow-100 text-yellow-700"
          }
        `}
                >
                  {rem.status}
                </span>

                <h6 className="font-bold text-gray-800 truncate">
                  {rem.subject}
                </h6>

                <p className="text-gray-500 mt-1">
                  Total Mail Sent: {rem.totalSent}
                </p>

                <p className="text-gray-500">Success: {rem.success}</p>

                <p className="text-gray-500 text-sm">
                  Scheduled: {rem.scheduledTime}
                </p>
              </div>
            ))}
        </div>

        {/* === Add Responder Modal === */}
        {isAddResponderModalOpen &&
          createPortal(
            <div className="fixed inset-0 bg-black/60 z-[9999] flex items-center justify-center">
              {/* Modal Box */}
              <div className="bg-white w-[700px] h-[250px] p-6 rounded-xl shadow-2xl relative">
                <h2 className="text-xl font-semibold text-gray-800 mb-4 text-center">
                  Create Responder
                </h2>

                <input
                  type="file"
                  accept=".xlsx,.xls"
                  onChange={handleFileChange}
                  className="mb-4 border p-2 rounded w-full"
                />

                <div className="flex justify-end w-full mt-9">
                  <button
                    onClick={() => setIsAddResponderModalOpen(false)}
                    className="px-4 py-2 bg-gray-400 text-white rounded hover:bg-gray-500 mr-3"
                  >
                    Close
                  </button>

                  {!selectedFile && !isUploadSuccess && (
                    <button
                      onClick={() => {
                        const link = document.createElement("a");
                        link.href = "/Sample_Responder_Sheet.xlsx";
                        link.download = "Sample_Responder_Sheet.xlsx";
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                      }}
                      className="px-4 py-2 bg-[#3bb290] text-white rounded hover:bg-[#339c7c] mr-3"
                    >
                      Download Sample
                    </button>
                  )}

                  <button
                    onClick={handleUpload}
                    disabled={isUploading}
                    className={`px-4 py-2 rounded text-white
                  ${
                    isUploading
                      ? "bg-gray-400 cursor-not-allowed"
                      : "bg-[#fc8e11] hover:bg-[#e47e0f]"
                  }`}
                  >
                    {isUploading ? "Uploading..." : "Upload"}
                  </button>
                </div>
              </div>
            </div>,
            document.body,
          )}
        {/* here i want like that  */}
        {isAddReminderModalOpen &&
          createPortal(
            <div className="fixed inset-0 bg-black/60 z-[9999] flex items-center justify-center">
              <div className="bg-white w-[620px] rounded-xl shadow-2xl p-6">
                {/* Title */}
                <h2 className="text-xl font-medium text-center mb-6">
                  Create Reminder
                </h2>

                {/* Email Subject */}
                <input
                  type="text"
                  placeholder="Email Subject"
                  value={emailSubject}
                  onChange={(e) => setEmailSubject(e.target.value)}
                  className="w-full border rounded-md px-4 py-3 mb-1"
                />
                {errors.emailSubject && (
                  <p className="text-red-500 text-sm mb-3">
                    {errors.emailSubject}
                  </p>
                )}

                {/* Parameter Dropdown */}
                <select
                  value=""
                  onChange={(e) => {
                    const value = e.target.value;
                    if (!value) return;

                    setEmailBody((prev) => {
                      if (!prev) return value;
                      return `${prev} ${value}`;
                    });

                    e.target.value = "";
                  }}
                  className="w-full border rounded-md px-4 py-3 mb-4 text-gray-600 focus:outline-none focus:ring-1 focus:ring-gray-400"
                >
                  <option value="">Parameter</option>
                  <option value="##ResponderName##">Responder Name</option>
                  <option value="##SurveyDeadline##">Survey Deadline</option>
                  <option value="##SurveyName##">Survey Name</option>
                  <option value="##SurveyLink##">Survey Link</option>
                </select>

                {/* Toolbar (visual only, matches image) */}
                <div className="border rounded-md mb-1 overflow-hidden">
                  <JoditEditor
                    value={emailBody}
                    config={joditConfig}
                    onChange={(content) => {
                      emailBodyRef.current = content; // always fresh
                    }}
                    onBlur={(content) => {
                      setEmailBody(content); // commit once
                      emailBodyRef.current = content;
                    }}
                  />
                </div>

                {errors.emailBody && (
                  <p className="text-red-500 text-sm mb-3">
                    {errors.emailBody}
                  </p>
                )}

                {/* Date & Time */}
                <div className="flex gap-4 mb-1">
                  <div className="flex-1">
                    <input
                      type="date"
                      value={date}
                      onChange={(e) => setDate(e.target.value)}
                      className="w-full border rounded-md px-4 py-3"
                    />
                    {errors.date && (
                      <p className="text-red-500 text-sm mt-1">{errors.date}</p>
                    )}
                  </div>

                  <div className="flex-1">
                    <input
                      type="time"
                      value={time}
                      onChange={(e) => setTime(e.target.value)}
                      className="w-full border rounded-md px-4 py-3"
                    />
                    {errors.time && (
                      <p className="text-red-500 text-sm mt-1">{errors.time}</p>
                    )}
                  </div>
                </div>

                {/* Checkbox */}
                <label className="flex items-center gap-2 text-gray-700 mb-6 mt-5">
                  <input
                    type="checkbox"
                    checked={onlyIncomplete}
                    onChange={() => setOnlyIncomplete(!onlyIncomplete)}
                  />
                  Only remind people who haven’t finished the survey
                </label>

                {/* Footer */}
                <div className="flex justify-end gap-4">
                  <button
                    onClick={() => setIsAddReminderModalOpen(false)}
                    className="text-gray-700"
                  >
                    Cancel
                  </button>

                  <button
                    className="bg-[#fc8e11] text-white px-6 py-2 rounded-md"
                    onClick={async () => {
                      if (!validateReminderForm()) return;

                      try {
                        const token = localStorage.getItem("JWTToken");

                        const payload = {
                          token,
                          subject: emailSubject,
                          body: emailBody,
                          scheduledTime: buildScheduledTime(),
                          surveyUID: assessmentUID,
                        };

                        console.log("Schedule Reminder Payload:", payload);

                        const response =
                          await surveyService.ScheduleReminder(payload);

                        if (response.status === "Success") {
                          showAlert(
                            "success",
                            response.message ||
                              "Reminder scheduled successfully",
                          );

                          setIsAddReminderModalOpen(false);

                          // Reset form
                          setEmailSubject("");
                          setEmailBody("");
                          setDate("");
                          setTime("");
                          setOnlyIncomplete(false);
                          setErrors({});
                        } else {
                          showAlert(
                            "error",
                            response.message || "Failed to schedule reminder",
                          );
                        }
                      } catch (error) {
                        console.error("Schedule Reminder Error:", error);
                        showAlert(
                          "error",
                          error.message || "Something went wrong",
                        );
                      }
                    }}
                  >
                    Create Reminder
                  </button>
                </div>
              </div>
            </div>,
            document.body,
          )}

        {isViewReminderOpen &&
          selectedReminder &&
          createPortal(
            <div className="fixed inset-0 bg-black/60 z-[9999] flex items-center justify-center">
              <div className="bg-white w-[700px] rounded-xl shadow-2xl p-8">
                <h2 className="text-2xl font-serif text-center mb-8">
                  Reminder Details
                </h2>

                <div className="space-y-4 text-gray-800 text-[15px]">
                  <p>
                    <span className="font-semibold">Subject:</span>{" "}
                    {selectedReminder.subject}
                  </p>

                  <p>
                    <span className="font-semibold">
                      Total Send Success Mail:
                    </span>{" "}
                    {selectedReminder.success}
                  </p>

                  <p>
                    <span className="font-semibold">Total Mail Send:</span>{" "}
                    {selectedReminder.totalSent}
                  </p>

                  <p>
                    <span className="font-semibold">Reminder send Time:</span>{" "}
                    {selectedReminder.scheduledTime}
                  </p>

                  <div>
                    <p className="font-semibold mb-2">Email Body:</p>
                    <div
                      className="border rounded-md p-4 bg-gray-50 text-gray-700 prose max-w-none"
                      dangerouslySetInnerHTML={{
                        __html: selectedReminder.body,
                      }}
                    />
                  </div>
                </div>

                <div className="flex justify-end mt-8">
                  <button
                    onClick={() => setIsViewReminderOpen(false)}
                    className="text-gray-700 hover:underline"
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>,
            document.body,
          )}
      </div>

      <NormalAlert
        show={alert.show}
        type={alert.type}
        message={alert.message}
        onClose={() => setAlert({ ...alert, show: false })}
      />
    </>
  );
};
export default ManageResponder;
